<template>
  <div>
    <div class="form-list">
      <div class="form-header">일반</div>
      <el-form :model="formModel" label-width="120px" label-position="left">
        <el-form-item label="X / Y">
          <el-input-number v-model="formModel.x" :precision="0" controls-position="right" :style="smallField"></el-input-number>
          <el-input-number v-model="formModel.y" :precision="0" controls-position="right" :style="smallField"></el-input-number>
        </el-form-item>
        <el-form-item label="가로 / 세로">
          <el-input-number v-model="formModel.width" :min="1" :precision="0" controls-position="right" :style="smallField"></el-input-number>
          <el-input-number v-model="formModel.height" :min="1" :precision="0" controls-position="right" :style="smallField"></el-input-number>
        </el-form-item>
        <el-form-item label="회전">
          <el-input-number v-model="formModel.r" :precision="0" controls-position="right" :style="fullField"></el-input-number>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-list">
      <div class="form-header">대상</div>
      <el-form :model="formModel" label-width="120px" label-position="left">
        <el-form-item label="레이블">
          <el-input v-model="formModel.label" :style="fullField"></el-input>
        </el-form-item>
        <el-form-item label="레이블 보기">
          <el-checkbox v-model="formModel.showLabelFlag" true-label="1" false-label="0"></el-checkbox>
        </el-form-item>
        <el-form-item label="레이블 박스 보기">
          <el-checkbox v-model="formModel.showLabelBoxFlag" true-label="1" false-label="0"></el-checkbox>
        </el-form-item>
        <el-form-item label="레이블 색">
          <w-color-field v-model="formModel.labelColor" :style="fullField"></w-color-field>
        </el-form-item>
        <el-form-item label="레이블 박스 색">
          <w-color-field v-model="formModel.labelBoxColor" :style="fullField"></w-color-field>
        </el-form-item>
        <el-form-item label="레이블 크기">
          <el-input-number v-model="formModel.labelOptions.labelSize" :min="1" controls-position="right" :style="fullField"></el-input-number>
        </el-form-item>
        <el-form-item label="레이블 위치">
          <w-label-position-select v-model="formModel.labelPosition"></w-label-position-select>
        </el-form-item>
        <el-form-item label="폰트">
          <el-select v-model="formModel.labelFont" :style="fullField">
            <el-option v-for="item in MapConst.FONT_FAMILIES" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="폰트 굵기">
          <el-checkbox v-model="formModel.labelOptions.labelBold"></el-checkbox>
        </el-form-item>
        <el-form-item label="이미지 타입">
          <el-radio-group v-model="formModel.styleOptions.imageType">
            <el-radio label="flat">FLAT</el-radio>
            <el-radio label="3d">3D</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="이미지">
          <w-image-select v-model="formModel.customimageId"></w-image-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-list">
      <div class="form-header">가상 장애 효과</div>
      <el-form :model="formModel" label-width="120px" label-position="left">
        <el-form-item label="가상 효과 적용">
          <el-checkbox v-model="formModel.virtualEffectShowFlag" true-label="1" false-label="0"></el-checkbox>
        </el-form-item>
        <el-form-item label="가상 효과 색">
          <w-color-field v-model="formModel.virtualEffectColor" :style="fullField"></w-color-field>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import WColorField from '@/components/form/ColorField';

import ObjectProperty from '@/mixins/topologymap/object-property';

import WImageSelect from '@/views/topologymap/components/property/ImageSelect';
import WLabelPositionSelect from '@/views/topologymap/components/property/LabelPositionSelect';

export default {
  name: 'WVirtualObjectProperty',
  components: {
    WColorField,
    WImageSelect,
    WLabelPositionSelect,
  },
  mixins: [ObjectProperty],
  data() {
    return {};
  },
};
</script>
<style module>
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/property/VirtualObjectProperty.vue